import { render, staticRenderFns } from "./DeleteCertificateDialog.vue?vue&type=template&id=3690648a&"
import script from "./DeleteCertificateDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteCertificateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports